(() => {
  if (customElements.get('wx-india-companions')) return;
  customElements.define('wx-india-companions', class extends HTMLElement {
    connectedCallback() {
      if (this.closest('quick-add-modal, quick-view, quick-view-modal, [data-quick-view]')) {
        this.remove();
        return;
      }
      if (this.boundSubmit) return;
      this.boundSubmit = this.submit.bind(this);
      this.addEventListener('submit', this.boundSubmit);
    }
    disconnectedCallback() {
      if (this.boundSubmit) this.removeEventListener('submit', this.boundSubmit);
      this.boundSubmit = null;
    }
    async submit(event) {
      const form = event.target.closest('[data-companion-form]');
      if (!form || !this.contains(form) || !window.fetch || !window.FormData) return;
      event.preventDefault();
      event.stopPropagation();
      if (form.dataset.busy === 'true') return;
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[role="status"]');
      const cartLink = form.querySelector('.wxic__cart-link');
      const cart = document.querySelector('cart-drawer');
      const body = new FormData(form);
      form.dataset.busy = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      cartLink.hidden = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      let confirmed = false;
      let rejected = false;
      try {
        let sectionIds = [];
        if (cart && typeof cart.getSectionsToRender === 'function') {
          sectionIds = cart.getSectionsToRender().map(section => section.id).filter(Boolean).slice(0, 5);
          if (sectionIds.length) {
            body.set('sections', sectionIds.join(','));
            body.set('sections_url', window.location.pathname);
          }
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
        }
        const response = await fetch(`${form.action.replace(/\.js$/, '')}.js`, {
          method: 'POST', credentials: 'same-origin', signal: controller.signal, headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          rejected = true;
          status.textContent = typeof result.description === 'string' ? result.description : form.dataset.error;
          return;
        }
        confirmed = true;
        status.textContent = form.dataset.added;
        cartLink.hidden = false;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'wx-india-companions', productVariantId: body.get('id'), cartData: result});
        }
        const sectionsValid = sectionIds.length && sectionIds.every(id => typeof result.sections?.[id] === 'string');
        if (cart && sectionsValid && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        }
      } catch (_) {
        status.textContent = confirmed ? form.dataset.added : form.dataset.uncertain;
        cartLink.hidden = false;
      } finally {
        clearTimeout(timeout);
        button.removeAttribute('aria-busy');
        if (confirmed || rejected) {
          button.disabled = false;
          delete form.dataset.busy;
        }
      }
    }
  });
})();
